<div
	class="flex flex-col dark:shadow-around h-screen left-0 absolute overflow-hidden bottom-0 top-0 3xl:border-l 3xl:border-[var(--color-border)]"
	id="ui-nav"
	[class.z-sub-nav]="subNavOpen()"
	[class.shadow-around]="subNavOpen()"
	#uiNav
>
	@if (appNavVisible()) {
		<ui-app-nav
			[environment]="environment()"
			[apps]="apps()"
			[activeApp]="activeApp()"
			[navColor]="navColor()"
			[navTranslations]="navTranslations()"
			class="bg-primary-100 shrink-0 w-17 border-r border-r-secondary-200"
			[class.dark:bg-standard]="!usePrimaryNavColor()"
		></ui-app-nav>
	} @else if (logoPath()) {
		<img class="block h-8 outline-none w-10 mt-5 mb-12 mx-auto" [src]="logoPath()" alt="App Logo" />
	}
	<div class="flex grow h-screen relative">
		<div
			class="bg-primary-100 flex flex-col pb-4 z-nav grow w-17 border-r border-r-secondary-200"
			[class.dark:bg-standard]="!usePrimaryNavColor()"
			data-cy="ui-nav-main"
		>
			<ui-nav-list
				[items]="items()"
				[navColor]="navColor()"
				[openItem]="openedMenuPoint()"
				[beta]="beta()"
				[betaTranslation]="navTranslations()?.beta || ''"
				[currentUrl]="currentUrl()"
				(menuPointAction)="onMenuPointAction($event)"
				(closeMenu)="closeSubMenu()"
				class="flex-1"
			></ui-nav-list>
		</div>
		@if (subNavOpen()) {
			<div
				class="bg-primary-100 relative top-0 z-sub-nav border-l-4 border-l-white dark:border-l-transparent border-r border-r-secondary-200 h-screen left-0 w-62.5"
				[class.dark:bg-standard]="!usePrimaryNavColor()"
				[style.marginTop]="subMenuMarginTop()"
				(mouseleave)="onMouseLeave()"
				data-cy="ui-nav-sub"
			>
				<ui-sub-nav
					[menuItem]="openedMenuPoint()"
					[navColor]="navColor()"
					[currentUrl]="currentUrl()"
					(itemClick)="onMenuPointAction($event)"
				>
				</ui-sub-nav>
			</div>
		}
	</div>
</div>
